import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { ICampaign } from "interfaces";

const { Title, Text } = Typography;

export const CampaignShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<ICampaign>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Operadora</Title>
      <Text>{record?.health_insurer_id}</Text>

      <Title level={5}>Mensagem</Title>
      <Text>{record?.message}</Text>

      <Title level={5}>Tag</Title>
      <Text>{record?.tag}</Text>
    </Show>
  );
};
